import { PaymentTerms, ShippingMethod } from './orderPolicy';

export type OrderStatus =
  | 'PENDING_QUOTE'
  | 'QUOTE_CONFIRMED'
  | 'PENDING_PAYMENT'
  | 'PAYMENT_COMPLETED'
  | 'PROOF_IN_PROGRESS'
  | 'PROOF_FEEDBACK'
  | 'PROOF_APPROVED'
  | 'PRODUCTION'
  | 'SHIPPED'
  | 'COMPLETED'
  | 'CANCELLED';

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  PENDING_QUOTE: '견적 대기',
  QUOTE_CONFIRMED: '견적 확정',
  PENDING_PAYMENT: '결제 대기',
  PAYMENT_COMPLETED: '결제 완료',
  PROOF_IN_PROGRESS: '시안 작업중',
  PROOF_FEEDBACK: '시안 수정요청',
  PROOF_APPROVED: '최종 승인',
  PRODUCTION: '제작중',
  SHIPPED: '배송중',
  COMPLETED: '완료',
  CANCELLED: '취소',
};

// 관리자가 체크하는 작업 진행 단계: 주문확인 → 작업중 → 작업완료
export type WorkStatus = 'WAITING' | 'IN_PROGRESS' | 'COMPLETED';

export const WORK_STATUS_LABEL: Record<WorkStatus, string> = {
  WAITING: '주문확인',
  IN_PROGRESS: '작업중',
  COMPLETED: '작업완료',
};

export interface Order {
  id: string;
  proofToken?: string;
  orderNo: string;
  customerName: string;
  phone: string;
  email?: string | null;
  status: OrderStatus;
  workStatus?: WorkStatus;
  workStartedAt?: string | null;
  workCompletedAt?: string | null;
  carrier?: string | null;
  trackingNumber?: string | null;
  title?: string | null;
  company?: string | null;
  shape?: string | null;
  boxSize?: string | null;
  contentSize?: string | null;
  contentType?: string | null;
  deadline?: string | null;
  budget?: string | null;
  printOption?: string | null;
  route?: string | null;
  content?: string | null;
  referencePortfolio?: string | null;
  createdAt: string;
  updatedAt: string;
  quantity?: number;
  unitPrice?: number;
  totalPrice?: number;
  shippingMethod?: ShippingMethod;
  paymentTerms?: PaymentTerms;
  paymentDueDate?: string | null;
  paidAt?: string | null;
  // 지금 결제할 수 있는 상태인지 (선결제: 최종 승인 직후 / 후불결제: 최종 승인 이후 미결제)
  awaitingPayment?: boolean;
}

export interface GuestLookupCredentials {
  /** 선택: 입력하면 해당 주문번호의 주문을 조회 (비우면 가장 최근 주문) */
  orderNo?: string;
  name: string;
  phone: string;
  password: string;
}
